import { formatTime, getTimezoneAbbr } from "../../utils/time";

export function NowMarker({ now }: { now: number }) {
  const iso = new Date(now).toISOString();
  return (
    <div className="flex items-center gap-2 my-1.5 px-1">
      <div className="flex-1 h-px bg-rose-500" />
      <span className="text-[11px] font-semibold text-rose-600 tabular-nums">
        지금 · {formatTime(iso)} {getTimezoneAbbr()}
      </span>
      <div className="flex-1 h-px bg-rose-500" />
    </div>
  );
}
